<template>
  <div class="am-page">

    <v-row>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2ts')">
            <v-img
              src="https://thumbs.dreamstime.com/b/inversi%C3%B3n-en-el-futuro-del-ejemplo-vector-concepto-de-dise%C3%B1o-plano-para-la-las-finanzas-y-actividades-bancarias-elegantes-l%C3%ADnea-147763815.jpg"
              height="150px"></v-img>

            <v-card-title>
              Recaudacion Total <br />
              por Unidad Negocio
            </v-card-title>

            <v-card-subtitle> Asignacion por unidades. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2tsp')">
            <v-img
              src="https://thumbs.dreamstime.com/b/hombres-de-negocios-financieros-la-inversi%C3%B3n-que-aumentan-el-capital-y-beneficios-riqueza-ahorros-con-los-caracteres-dinero-las-136291027.jpg"
              height="150px"></v-img>

            <v-card-title> Recaudación total por sede </v-card-title>

            <v-card-subtitle> Asignacion total por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_prog')">
            <v-img src="https://www.theinit.com/wp-content/uploads/2021/04/FINANZAS.png" height="150px"></v-img>

            <v-card-title> Recaudación total por programa </v-card-title>

            <v-card-subtitle> Asignacion total por programas. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col 
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
       cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_corpo')">
            <v-img
              src="https://www.workday.com/content/dam/web/en-us/images/content/abstract-article-4@2x.png/jcr:content/renditions/original"
              height="150px"></v-img>

            <v-card-title> Recaudación Corporacion </v-card-title>

            <v-card-subtitle> Asignacion total. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col 
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2c')">
            <v-img
              src="https://static.vecteezy.com/system/resources/thumbnails/006/170/572/small/flat-design-of-financial-literacy-education-free-vector.jpg"
              height="150px"></v-img>

            <v-card-title> Certificaciones </v-card-title>

            <v-card-subtitle> Asignacion de todos los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('recaudacionv4')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl"
              style="background-color: #2e7d32;">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-multiple</v-icon>
              <v-chip color="light-green lighten-1" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Recaudacion Por Sede
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para recaudacion por sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="primary" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

        </template>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_prog_v4')">
            <div class="d-flex flex-column align-center justify-center py-6 bg-primary rounded-t-xl">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-check</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Asignación Por Programa
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para asignar programas por sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="primary" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

        </template>
      </v-col>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_sede_v4')">
            <div class="d-flex flex-column align-center justify-center py-6 bg-teal rounded-t-xl">
              <v-icon size="64" color="white" class="mb-2">mdi-map-marker-multiple</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Asignación por Sedes
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para asignar cobros según la ubicación o sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="teal" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_sede_v4')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>

            <v-card-title> Asignaciones Sede Nuevo</v-card-title>

            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card> -->
        </template>
      </v-col>
    </v-row>
    <v-row>

      <v-col
        
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_prog_v2')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>
            <v-card-title> Asignacion por programa </v-card-title>
            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_sede_v2')">
            <v-img
              src="https://media.istockphoto.com/id/1202048771/es/vector/el-personaje-del-hombre-de-negocios-exitoso-se-encuentra-en-una-postura-segura-en-enorme.jpg?s=612x612&w=0&k=20&c=KKJV2TKw4yZkpQAFdlymTZnw0bj7yHpJjaLIgWghodI="
              height="150px"></v-img>

            <v-card-title> Asignacion de Sede </v-card-title>

            <v-card-subtitle> Asignacion de los programas de una sede de cada gestion. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col 
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
      cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_negounidad_v2')">
            <v-img
              src="https://media.istockphoto.com/vectors/business-success-flat-cartoon-style-vector-illustration-vector-id1149316200"
              height="150px"></v-img>

            <v-card-title> Asignacion Por unidad de Negocio </v-card-title>

            <v-card-subtitle> Asignacion Por unidad de Negocio </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col 
      
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
      cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_corporacion_v2')">
            <v-img
              src="https://thumbs.dreamstime.com/b/hombres-de-negocios-financieros-la-inversi%C3%B3n-que-aumentan-el-capital-y-beneficios-riqueza-ahorros-con-los-caracteres-dinero-las-136291027.jpg"
              height="150px"></v-img>

            <v-card-title> Asignacion Corporacion </v-card-title>

            <v-card-subtitle> Asignacion de toda la corporacion por unidades de negocio </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col 
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
      cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_prog_v3')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>

            <v-card-title> Asignacion por programa X </v-card-title>

            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <!-- NUEVA SECCIÓN: ASIGNACIONES LADDER -->
    <div
      v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
      class="mt-5 mb-1 d-flex align-center px-4 py-3 rounded-lg"
      style="background: linear-gradient(135deg, #0d47a1 0%, #1565c0 60%, #1976d2 100%);">
      <v-icon color="amber accent-3" class="mr-2">mdi-lightning-bolt-circle</v-icon>
      <span class="white--text font-weight-bold text-uppercase" style="font-size: 0.95rem; letter-spacing: 0.06em;">
        Asignaciones Ladder 2026
      </span>
      <v-spacer></v-spacer>
      <v-chip
        color="pink accent-3"
        text-color="white"
        label
        small
        class="font-weight-black"
        style="font-size: 0.72rem; letter-spacing: 0.18em; padding: 0 10px;">
        ★ NUEVO
      </v-chip>
    </div>

    <v-row>
      <!-- Opción 1: Asignaciones Sede V8 -->
      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('AsignacionesV8')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl" style="background-color: #1565c0;">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-register</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">V8</v-chip>
            </div>
            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase" style="font-size: 1rem; line-height: 1.2;">
              Asignaciones Sede V8
            </v-card-title>
            <v-card-subtitle class="text-center text-body-2 px-3">
              Vista general y por encargado de cobranza.
            </v-card-subtitle>
            <v-divider class="my-2"></v-divider>
            <v-card-actions class="justify-center pb-3">
              <v-btn color="primary" text small>
                Ingresar <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>

      <!-- Opción 2: Asignaciones Ejecutivo V8 -->
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_ejecutivo_v8')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl" style="background-color: #f57c00;">
              <v-icon size="64" color="white" class="mb-2">mdi-chart-pie</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">V8</v-chip>
            </div>
            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase" style="font-size: 1rem; line-height: 1.2;">
              Vista Ejecutivo V8
            </v-card-title>
            <v-card-subtitle class="text-center text-body-2 px-3">
              Resumen gerencial por Unidad de Negocio y Sede.
            </v-card-subtitle>
            <v-divider class="my-2"></v-divider>
            <v-card-actions class="justify-center pb-3">
              <v-btn color="orange darken-2" text small>
                Ingresar <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>

      <!-- Opción 3: Asignaciones Sede V7 -->
      <!-- <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_sede_v7')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl" style="background-color: #6a1b9a;">
              <v-icon size="64" color="white" class="mb-2">mdi-history</v-icon>
              <v-chip color="light-blue lighten-2" text-color="white" small label class="font-weight-bold">V7</v-chip>
            </div>
            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase" style="font-size: 1rem; line-height: 1.2;">
              Asignaciones Sede V7
            </v-card-title>
            <v-card-subtitle class="text-center text-body-2 px-3">
              Cobranza detallada por Sede.
            </v-card-subtitle>
            <v-divider class="my-2"></v-divider>
            <v-card-actions class="justify-center pb-3">
              <v-btn color="purple darken-2" text small>
                Ingresar <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-col> -->

      <!-- Opción 4: Recaudación V8 -->
      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('recaudacionv8')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl" style="background-color: #00695c;">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-check</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">V8</v-chip>
            </div>
            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase" style="font-size: 1rem; line-height: 1.2;">
              Recaudación V8
            </v-card-title>
            <v-card-subtitle class="text-center text-body-2 px-3">
              Reporte de recaudación y recibos de pago.
            </v-card-subtitle>
            <v-divider class="my-2"></v-divider>
            <v-card-actions class="justify-center pb-3">
              <v-btn color="teal darken-2" text small>
                Ingresar <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <div
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || is_rol_administrador">
      <p class="mt-4 green white--text"><b class="pl-9">Proyecciones:</b></p>
    </div>

    <div class="am-body">

      <!-- ── Recaudación ──────────────────────────────── -->
      <div class="am-section-header am-section--indigo">
        <v-icon small color="white" class="mr-1">mdi-cash-register</v-icon> Recaudación
      </div>
      <v-row dense class="mb-2 px-12 py-8">

        <v-col v-if="ismauren || (ispermitido && cid != 15 && cid != 25 || cid == 26 || is_rol_administrador)"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacionesv2ts')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#1a237e,#283593)">
              <v-icon size="38" color="white">mdi-domain</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Recaudación Total por Unidad Negocio</div>
              <div class="am-card__sub">Asignación por unidades</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacionesv2tsp')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#283593,#1565c0)">
              <v-icon size="38" color="white">mdi-map-marker-multiple-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Recaudación Total por Sede</div>
              <div class="am-card__sub">Asignación total por cada sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 15 || cid == 25 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asig_total_prog')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#1565c0,#0288d1)">
              <v-icon size="38" color="white">mdi-book-multiple-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Recaudación Total por Programa</div>
              <div class="am-card__sub">Asignación total por programas</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asig_total_corpo')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#0277bd,#01579b)">
              <v-icon size="38" color="white">mdi-city-variant-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Recaudación Corporación</div>
              <div class="am-card__sub">Asignación total</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="(ispermitido && cid != 15 && cid != 25) || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacionesv2c')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#4527a0,#6a1b9a)">
              <v-icon size="38" color="white">mdi-certificate-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Certificaciones</div>
              <div class="am-card__sub">Todos los programas por cada sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 22 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('recaudacionv4')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#2e7d32,#43a047)">
              <v-icon size="38" color="white">mdi-cash-multiple</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">
                Recaudación por Sede
                <v-chip x-small color="light-green lighten-1" dark label class="ml-1 font-weight-bold">NUEVO</v-chip>
              </div>
              <div class="am-card__sub">Nueva funcionalidad por sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 22 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_prog_v4')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#1565c0,#1976d2)">
              <v-icon size="38" color="white">mdi-cash-check</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">
                Asignación por Programa
                <v-chip x-small color="pink lighten-2" dark label class="ml-1 font-weight-bold">NUEVO</v-chip>
              </div>
              <div class="am-card__sub">Nueva funcionalidad para programas por sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 22 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_sede_v4')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#00695c,#00897b)">
              <v-icon size="38" color="white">mdi-map-marker-multiple</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">
                Asignación por Sedes
                <v-chip x-small color="pink lighten-2" dark label class="ml-1 font-weight-bold">NUEVO</v-chip>
              </div>
              <div class="am-card__sub">Cobros según ubicación o sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 22 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_prog_v2')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#0277bd,#0288d1)">
              <v-icon size="38" color="white">mdi-book-open-variant</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Asignación por Programa</div>
              <div class="am-card__sub">Programas por cada sede</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido || cid == 3 || cid == 17 || cid == 22 || cid == 26 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_sede_v2')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#283593,#3949ab)">
              <v-icon size="38" color="white">mdi-office-building-marker-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Asignación de Sede</div>
              <div class="am-card__sub">Programas de una sede por gestión</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="ispermitido && cid != 15 && cid != 25"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_negounidad_v2')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#1a237e,#1565c0)">
              <v-icon size="38" color="white">mdi-domain</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Asignación por Unidad de Negocio</div>
              <div class="am-card__sub">Asignación por unidad de negocio</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="cid == 1 || cid == 14 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_corporacion_v2')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#01579b,#0277bd)">
              <v-icon size="38" color="white">mdi-city</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Asignación Corporación</div>
              <div class="am-card__sub">Corporación por unidades de negocio</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="cid == 1 || cid == 14 || is_rol_administrador"
          cols="12" sm="6" md="4" lg="3">
          <v-card class="am-card" @click="asignacionopen('asignacion_prog_v3')">
            <div class="am-card__icon" style="background:linear-gradient(135deg,#37474f,#546e7a)">
              <v-icon size="38" color="white">mdi-book-search-outline</v-icon>
            </div>
            <v-card-text class="am-card__text">
              <div class="am-card__title">Asignación por Programa X</div>
              <div class="am-card__sub">Programas por cada sede</div>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>

      <!-- ── Proyecciones ─────────────────────────────── -->
      <template v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || is_rol_administrador">
        <div class="am-section-header am-section--green">
          <v-icon small color="white" class="mr-1">mdi-chart-line</v-icon> Proyecciones
        </div>
        <v-row dense class="mb-2 px-12 py-8">

          <v-col v-if="cid == 1 || cid == 14 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('proy_unidad')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#1b5e20,#2e7d32)">
                <v-icon size="38" color="white">mdi-chart-line</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Proyección por Unidad</div>
                <div class="am-card__sub">Proyección por unidad de negocio</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('proy_programas')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#2e7d32,#388e3c)">
                <v-icon size="38" color="white">mdi-chart-bar</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Proyección Programas</div>
                <div class="am-card__sub">Proyección por programas</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('proy_sedes')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#388e3c,#43a047)">
                <v-icon size="38" color="white">mdi-chart-areaspline</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Proyección por Sede</div>
                <div class="am-card__sub">Proyección por sede de unidad</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('proy_corporacion')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#43a047,#66bb6a)">
                <v-icon size="38" color="white">mdi-trending-up</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Proyección Corporación</div>
                <div class="am-card__sub">Proyección de toda la corporación</div>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </template>

      <!-- ── Asignaciones totales ─────────────────────── -->
      <template v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || cid == 26 || is_rol_administrador">
        <div class="am-section-header am-section--purple">
          <v-icon small color="white" class="mr-1">mdi-sigma</v-icon> Asignaciones totales
        </div>
        <v-row dense class="mb-2 px-12 py-8">

          <v-col v-if="cid == 1 || cid == 14 || cid == 26 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('asig_total_unidad')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#4a148c,#6a1b9a)">
                <v-icon size="38" color="white">mdi-domain</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Total por Unidad</div>
                <div class="am-card__sub">Asignaciones totales por unidad</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || cid == 26 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('asig_total_sede')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#6a1b9a,#7b1fa2)">
                <v-icon size="38" color="white">mdi-map-marker-outline</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Total por Sede</div>
                <div class="am-card__sub">Asignaciones totales por sede</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || cid == 26 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('asig_total_programa')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#7b1fa2,#8e24aa)">
                <v-icon size="38" color="white">mdi-book-open-variant</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Total por Programa</div>
                <div class="am-card__sub">Asignaciones totales por programa</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 26 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('asig_total_corporacion')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#8e24aa,#ab47bc)">
                <v-icon size="38" color="white">mdi-city-variant-outline</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Total Corporación</div>
                <div class="am-card__sub">Asignaciones de toda la corporación</div>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </template>

      <!-- ── Envíos Netsuite ──────────────────────────── -->
      <template v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || is_rol_administrador">
        <div class="am-section-header am-section--red">
          <v-icon small color="white" class="mr-1">mdi-cloud-upload-outline</v-icon> Envíos Netsuite
        </div>
        <v-row dense class="mb-2 px-12 py-8">

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="asignacionopen('asig_envios_a_netsuite')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#b71c1c,#c62828)">
                <v-icon size="38" color="white">mdi-send-outline</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Enviados a Netsuite</div>
                <div class="am-card__sub">Consulta de envíos realizados</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="cid == 1 || cid == 14 || cid == 15 || cid == 25 || is_rol_administrador"
            cols="12" sm="6" md="4" lg="3">
            <v-card class="am-card" @click="openlink('/portal/extreme')">
              <div class="am-card__icon" style="background:linear-gradient(135deg,#37474f,#546e7a)">
                <v-icon size="38" color="white">mdi-receipt-text-outline</v-icon>
              </div>
              <v-card-text class="am-card__text">
                <div class="am-card__title">Recaudación Recibos</div>
                <div class="am-card__sub">Dev Extreme</div>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ispermitido: false,
      ismauren: false,
      is_rol_administrador: false,
    };
  },
  computed: {
    cid() {
      return this.$store.state.CARGO.id;
    },
  },
  methods: {
    asignacionopen(url) {
      this.$router.push({ name: url });
    },
    openlink(url) {
      window.location.href = url;
    },
  },
  mounted() {
    let cid = this.$store.state.CARGO.id;
    this.is_rol_administrador = cid == 4 || cid == 22;
    this.ismauren = this.$store.state.DATA_USER.id == 3506;
    this.ispermitido = cid == 19 || cid == 14 || cid == 15 || cid == 25 || cid == 1;
  },
};
</script>

<style scoped>
.am-page { min-height: 100vh; background: #f5f7fa; }

.am-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.am-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.am-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.am-body { padding: 20px 24px; }

.am-section-header {
  display: flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  margin-bottom: 10px;
  margin-top: 8px;
}
.am-section--indigo { background: linear-gradient(90deg, #1a237e, #283593); }
.am-section--green  { background: linear-gradient(90deg, #1b5e20, #2e7d32); }
.am-section--purple { background: linear-gradient(90deg, #4a148c, #6a1b9a); }
.am-section--red    { background: linear-gradient(90deg, #b71c1c, #c62828); }

.am-card {
  border-radius: 10px !important;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  border: 1px solid #e3e8f0 !important;
}
.am-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;
}

.am-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 86px;
}

.am-card__text { padding: 10px 14px 12px !important; }

.am-card__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1a237e;
  line-height: 1.3;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.am-card__sub {
  font-size: 0.75rem;
  color: #78909c;
  margin-top: 3px;
  line-height: 1.3;
}
</style>
